<template>
  <div class="orderList" id="orderList">
    <div class="nodata" v-if="finished && datas == ''">
      <img class="img" src="./../assets/img/dd-null.png" />
      <span class="text">还没有相关订单~</span>
    </div>

    <van-list v-model="loading" :finished="finished" @load="getDatas" >
      <div class="list-item" v-for="(items, index) in datas" :key="items.id">
        <div class="van-cell">
          <div @click="godetail(items.id_order)" class="van-cell__title noborder">
            <div class="van-cell__title-num">
              <span>订单编号：</span>
              <span style="color: rgba(38, 38, 38, 1)">{{ items.ordersn }}</span>
            </div>
            <!-- <span class="float-right theme-col" v-html="items.order_status_name==''?items.pay_status:items.order_status_name"></span> -->
            <span class="float-right theme-col" v-if="items.status == -1">已取消</span>
            <span class="float-right theme-col" v-if="items.status == 0">待付款</span>
            <span class="float-right theme-col" v-if="items.status == 1">待发货</span>
            <span class="float-right theme-col" v-if="items.status == 2">
              {{ items.order.refund_status == 1 ? ' 部分退款' : items.order.refund_status == 2 ? '全部退款' : '部分发货'  }}
            </span>
            <span class="float-right theme-col" v-if="items.status == 3">
              {{ items.order.refund_status == 1 ? ' 部分退款' : items.order.refund_status == 2 ? '全部退款' : '已发货'  }}
            </span>
            <span class="float-right theme-col" v-if="items.status == 4">交易关闭</span>
          </div>
        </div>

        <div class="list-card">
          <van-card class="goodsonelist" v-for="item in items.products" :key="item.id">
            <router-link
              slot="thumb"
              class="goodsimgbox"
              :to="{ name: 'Order', query: { id: items.id_order, type: type } }"
            >
              <img
                :src="item.img"
                @click="godetail(items.id_order)"
                onerror="src='/static/errorimg1.png'"
              />
            </router-link>
            <div @click="godetail(items.id_order)" slot="title" class="van-card-title">
              <div class="ellipseal">
                <span class="tagbox">
                  <span class="tag xl" v-if="item.source == 4"> 一乡一物 </span>
                  <span class="tag xl" v-if="item.source == 3">卡券</span>
                  <span class="tag zc" v-if="item.source == 2">直充</span>
                  <span plain class="tag jd" v-if="item.source == 1">优选</span>
                  <span class="tag yx" v-if="item.source == 6">严选</span>
                </span>
                {{ item.name }}
              </div>
            </div>
            <div slot="desc" class="van-card-desc theme-col">
              <span class="van-card-desc-integral">
                <span v-if="Number(item.points)">{{ item.points }}{{ unit }}</span>
                <span v-if="item.cash">
                  <span><span v-if="Number(item.points)">+</span>{{ item.cash }}</span>
                  <span>元</span>
                </span>
              </span>
              <span class="van-card-desc-num" style="display: inline-block; float: right">
                × {{ item.nums }}
              </span>
            </div>
          </van-card>
          <div class="card-bottom">
            <span class="card-all">共{{ items.nums }}件商品：</span>
            <span v-if="type == 1">订单总额</span>
            <span v-if="type != 1">合计</span>：
            <span v-if="items.totalpoints">{{ items.totalpoints }}{{ unit }}</span>
            <span v-if="items.total_cash">
              <span><span v-if="items.totalpoints">&nbsp;+&nbsp;</span>{{ items.total_cash }}</span>
              <span>元</span>
            </span>
          </div>
        </div>
        <div class="product-btn-all">
          <div class="product-btn">
            <router-link :to="{ name: 'Order', query: { id: items.id_order, type: type } }">
              <van-button class="order-btn" size="small">查看详情</van-button>
            </router-link>
            <van-button
              size="small"
              class="order-btn"
              v-if="items.is_cancel > 0"
              @click="cancelOrder(items.id_order, index, items.status + 1)"
            >
              取消订单
            </van-button>
            <van-button
              class="order-btn to-payfor"
              size="small"
              v-if="items.status == 0"
              @click="payOrder(items.id_order)"
            >
              去支付
            </van-button>
            <van-button
              size="small"
              class="order-btn"
              v-if="items.status == -1"
              @click="delOrder(items.id_order, index)"
            >
              删除订单
            </van-button>
          </div>
        </div>
      </div>
      <div v-if="!loading && finished && datas != ''" class="nomore">
        <div class="theEnd">已经到底了</div>
      </div>
    </van-list>
  </div>
</template>
<script>
import pay from "@/mixins/pay.js";
export default {
  name: "orderlist",
  mixins: [pay],
  data() {
    return {
      datas: [],
      page: 0,
      finished: false,
      loading: false,
      type: this.$route.query.type,
      btn: false
    };
  },

  computed: {
    unit: function() {
      return this.$store.state.unitinfo.name;
    },
    type: function() {
      if (this.$route.query.type == 1) {
        return 1;
      } else if (this.$route.query.type == 2) {
        return 2;
      } else if (this.$route.query.type == 3) {
        return 3;
      } else if (this.$route.query.type == 4) {
        return 4;
      } else {
        return 0;
      }
    }
  },
  methods: {
    godetail: function(id) {
      this.$router.push({ name: "Order", query: { id: id, type: this.type } });
    },
    getDatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      setTimeout(() => {
        this.page++;
        console.log("11111111111111111", this.page);
        this.$api.get(
          "order/orders/list",
          {
            id_example: mallid,
            token_user: isUser,
            status: this.type,
            page: this.page
          },
          res => {
            if (res.data.code == "100") {
              if (res.data.data.length == 0) {
                _this.finished = true;
                _this.loading = false;
              } else {
                for (let i = 0; i < res.data.data.length; i++) {
                  _this.datas.push(res.data.data[i]);
                }
                _this.loading = false;
              }
            } else {
              this.$toast.alert(res.data.message);
              _this.loading = false;
            }
          }
        );
      }, 50);
    },
    //去支付
    payOrder(id) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认支付该订单？"
        })
        .then(async () => {
          this.wxPay(id);
        })
        .catch(() => {
          // on cancel
        });
    },
    //删除订单
    delOrder: function(id, index) {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认删除该订单？"
        })
        .then(() => {
          this.$api.post(
            "order/orders/delete",
            { id_example: mallid, token_user: isUser, id_order: id },
            res => {
              if (res.data.code == "100") {
                this.$toast(res.data.message);
                this.datas.splice(index, 1);
              } else {
                this.$toast(res.data.message);
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },
    //取消订单
    cancelOrder: function(id, index, type) {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认取消该订单？"
        })
        .then(() => {
          this.$api.post(
            "order/orders/cancel",
            {
              id_example: mallid,
              token_user: isUser,
              id_order: id,
              type: type
            },
            res => {
              if (res.data.code == "100") {
                //              this.datas.splice(index, 1)
                this.datas = [];
                this.$toast(res.data.message);
                this.page = 0;
                this.getDatas();
              } else {
                this.$toast(res.data.message);
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    }
    //确认收货
    //      confirmOrder: function (id,index){
    //        var isUser=localStorage.getItem("BLHuser")
    //        var mallid=localStorage.getItem("mallid");
    //        this.$dialog.confirm({
    //          title: '提示',
    //          message: '确认收货？'
    //        }).then(() => {
    //          this.$api.post('order/orders/delete', {id_example:mallid,token_user:isUser,id_order:id}, res => {
    //            if(res.data.code == '100'){
    //              this.$toast(res.data.message)
    //              this.datas.splice(index, 1)
    //            }else{
    //              this.$toast(res.data.message)
    //            }
    //          })
    //        }).catch(() => {
    //          // on cancel
    //        });
    //      }
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.orderList {
  width: 100%;
  min-height: 100vh;

  .van-list {
    margin-top: 1.15rem;
  }

  .list-item {
    background-color: #fff;
    overflow: hidden;
    margin-top: 0.2rem;
    box-sizing: border-box;
    padding: 0 0.3rem;

    .van-cell {
      padding: 0.26rem 0;

      &::after {
        border: none !important;
      }

      .van-cell__title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .van-cell__title-num {
          font-size: 0.28rem;
          font-weight: 400;
          color: rgba(38, 38, 38, 0.5);
          line-height: 0.48rem;
        }
      }
    }

    .list-card {
      border-bottom: 0.02rem solid #f5f5f5;
      padding-bottom: 0.36rem;

      .card-bottom {
        display: flex;
        justify-content: flex-end;
        font-size: 0.28rem;
        font-weight: 400;
        color: #262626;

        .card-all {
          font-size: 0.28rem;
          font-weight: 400;
          color: rgba(38, 38, 38, 0.5);
        }

        span {
          font-size: 0.28rem;
          font-weight: 400;
          color: #262626;
        }
      }

      .van-card {
        background-color: #fff;
      }

      .goodsonelist {
        padding-bottom: 0.36rem;
        .ellipseal {
          font-size: 0.26rem;
          font-weight: 500;
          color: #262626;
          line-height: 0.42rem;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -moz-box-orient: vertical;
          box-orient: vertical;
          -webkit-line-clamp: 3;
          line-clamp: 3;
          overflow: hidden;
        }
        .goodsimgbox {
          width: 2.2rem;
          height: 2.2rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .van-card__content {
          position: relative;

          .van-card-desc {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: absolute;
            bottom: 0;

            .van-card-desc-integral {
              font-size: 0.28rem;
              font-weight: 400;
              color: #262626;
              line-height: 0.48rem;
            }

            .van-card-desc-num {
              font-size: 0.24rem;
              font-weight: 400;
              color: #929292;
              line-height: 0.42rem;
            }
          }
        }
      }
    }

    .product-btn-all {
      padding: 0.3rem 0;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      .product-btn {
        .view-details {
        }

        .order-btn {
          width: 1.6rem;
          height: 0.52rem;
          border-radius: 0.4rem;
          border: 0.02rem solid #929292;
          font-size: 0.24rem;
          font-weight: 400;
          line-height: 0.52rem;
          text-align: center;
          color: #262626;
          margin-left: 0.1rem;
          .van-button__text {
            color: #262626 !important;
          }
        }
        .to-payfor {
          border: 0.02rem solid #fe6047;
          color: #fe5c42;
          .van-button__text {
            color: #fe5c42 !important;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderlist.vue